import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdf8783c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed bottom-4 right-4 z-[60] flex flex-col items-end gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "w-[min(100vw-2rem,380px)] h-[min(70vh,520px)] flex flex-col rounded-2xl border-2 border-stone-400/60 dark:border-amber-500/40 bg-white/90 dark:bg-stone-900/90 backdrop-blur-md shadow-2xl overflow-hidden"
}
const _hoisted_3 = { class: "flex items-center gap-3 px-4 py-3 border-b border-stone-200 dark:border-stone-700 bg-gradient-to-r from-stone-100/80 to-amber-50/60 dark:from-stone-800/80 dark:to-amber-900/30" }
const _hoisted_4 = { class: "relative w-10 h-10 rounded-full bg-gradient-to-br from-stone-300 to-stone-500 dark:from-stone-600 dark:to-stone-800 flex items-center justify-center ring-2 ring-amber-400/50 shadow-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-400 ring-2 ring-white dark:ring-stone-900 animate-pulse" }, null, -1))
const _hoisted_6 = { class: "flex-1 min-w-0" }
const _hoisted_7 = { class: "text-sm font-bold text-stone-800 dark:text-amber-200" }
const _hoisted_8 = { class: "text-xs text-stone-500 dark:text-stone-400 truncate" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "text-[10px] font-bold text-amber-600 dark:text-amber-400 block mb-0.5"
}
const _hoisted_11 = {
  key: 0,
  class: "flex justify-start"
}
const _hoisted_12 = { class: "bg-stone-100/90 dark:bg-stone-800/80 rounded-2xl rounded-bl-sm px-4 py-3 border border-stone-200/60 dark:border-stone-600/40" }
const _hoisted_13 = { class: "flex gap-1" }
const _hoisted_14 = { class: "flex gap-2" }
const _hoisted_15 = ["placeholder", "disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { class: "w-8 h-8 rounded-full bg-stone-500 dark:bg-stone-600 flex items-center justify-center ring-2 ring-amber-400/40" }
const _hoisted_19 = {
  key: 0,
  class: "text-sm font-semibold pr-1"
}

import { ref, watch, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import { Icon } from "@iconify/vue";
import { useChat } from "@/composables/useChat";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatWidget',
  setup(__props) {

const { t, locale } = useI18n();
const { messages, isLoading, sendMessage, clearChat, setWelcomeMessage } = useChat();

watch(locale, () => {
  if (messages.value.length === 1 && messages.value[0]?.id === "welcome") {
    setWelcomeMessage(t("chat.welcome"));
  }
});

const isOpen = ref(false);
const inputText = ref("");
const messagesRef = ref<HTMLElement | null>(null);

const scrollToBottom = async (): Promise<void> => {
  await nextTick();
  if (messagesRef.value) {
    messagesRef.value.scrollTop = messagesRef.value.scrollHeight;
  }
};

const handleSubmit = async (): Promise<void> => {
  const text = inputText.value;
  inputText.value = "";
  await sendMessage(text);
  await scrollToBottom();
};

watch(messages, scrollToBottom, { deep: true });
watch(isLoading, scrollToBottom);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "chat-panel" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:ghost",
                    class: "w-6 h-6 text-white/90"
                  }),
                  _hoisted_5
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("common.ghost")), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("chat.subtitle")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(clearChat) && _unref(clearChat)(...args))),
                  class: "p-1.5 text-stone-400 hover:text-stone-600 dark:hover:text-stone-200 transition-colors",
                  title: _unref(t)('chat.clearChat')
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:refresh",
                    class: "w-4 h-4"
                  })
                ], 8, _hoisted_9),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false)),
                  class: "p-1.5 text-stone-400 hover:text-stone-600 dark:hover:text-stone-200 transition-colors"
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:close",
                    class: "w-5 h-5"
                  })
                ])
              ]),
              _createElementVNode("div", {
                ref_key: "messagesRef",
                ref: messagesRef,
                class: "flex-1 overflow-y-auto px-4 py-3 space-y-3"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (msg) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: msg.id,
                    class: _normalizeClass([
              'flex',
              msg.role === 'user' ? 'justify-end' : 'justify-start',
            ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'max-w-[85%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed',
                msg.role === 'user'
                  ? 'bg-amber-400/90 dark:bg-amber-500/80 text-stone-900 rounded-br-sm'
                  : 'bg-stone-100/90 dark:bg-stone-800/80 text-stone-700 dark:text-stone-200 border border-stone-200/60 dark:border-stone-600/40 rounded-bl-sm',
              ])
                    }, [
                      (msg.role === 'assistant')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(t)("common.ghost")), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(msg.content), 1)
                    ], 2)
                  ], 2))
                }), 128)),
                (_unref(isLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                            return _createElementVNode("span", {
                              key: i,
                              class: "w-1.5 h-1.5 rounded-full bg-amber-400 animate-bounce",
                              style: _normalizeStyle({ animationDelay: `${(i - 1) * 150}ms` })
                            }, null, 4)
                          }), 64))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 512),
              _createElementVNode("form", {
                onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                class: "px-3 py-3 border-t border-stone-200 dark:border-stone-700 bg-stone-50/50 dark:bg-stone-900/50"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputText).value = $event)),
                    type: "text",
                    placeholder: _unref(t)('chat.placeholder'),
                    disabled: _unref(isLoading),
                    class: "flex-1 h-10 px-3 text-sm rounded-xl border border-stone-300 dark:border-stone-600 bg-white dark:bg-stone-800 text-stone-800 dark:text-stone-100 placeholder:text-stone-400 focus:outline-none focus:ring-2 focus:ring-amber-400/50 disabled:opacity-50"
                  }, null, 8, _hoisted_15), [
                    [_vModelText, inputText.value]
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: _unref(isLoading) || !inputText.value.trim(),
                    class: "cursor-pointer h-10 w-10 flex items-center justify-center rounded-xl bg-amber-400 dark:bg-amber-500 text-stone-900 hover:bg-amber-500 dark:hover:bg-amber-400 disabled:opacity-40 transition-colors"
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:send",
                      class: "w-4 h-4"
                    })
                  ], 8, _hoisted_16)
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (isOpen.value = !isOpen.value)),
      class: _normalizeClass([
        'group flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full shadow-lg border-2 transition-all duration-300',
        isOpen.value
          ? 'bg-stone-700 dark:bg-stone-800 border-stone-500 text-white'
          : 'bg-gradient-to-r from-stone-200 to-amber-200 dark:from-stone-700 dark:to-amber-800 border-amber-400/60 dark:border-amber-500/50 text-stone-800 dark:text-amber-100 hover:shadow-xl hover:scale-105',
      ]),
      "aria-label": _unref(t)('chat.openChat')
    }, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_unref(Icon), {
          icon: "mdi:ghost",
          class: "w-5 h-5 text-white"
        })
      ]),
      (!isOpen.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(t)("common.ghost")), 1))
        : _createCommentVNode("", true)
    ], 10, _hoisted_17)
  ]))
}
}

})